import { useApiStore } from '@/stores/apiStore';

import { DevicePlanChangeApi } from '@/../generated-client/apis/DevicePlanChangeApi';
import { DevicePlanChangeAction } from '../../generated-client/models';

let devicePlanChangeApi: DevicePlanChangeApi | null = null;
let lastConfig: unknown = null;

function getDevicePlanChangeApi(): DevicePlanChangeApi {
  const { apiConfig } = useApiStore.getState();

  // if config changed (token refresh), rebuild
  if (devicePlanChangeApi === null || lastConfig !== apiConfig) {
    devicePlanChangeApi = new DevicePlanChangeApi(apiConfig);
    lastConfig = apiConfig;
  }

  return devicePlanChangeApi;
}

export const createDevicePlanChangeRequest = async (
  macAddress: string,
  action: DevicePlanChangeAction,
) => {
  const api = getDevicePlanChangeApi();
  return await api.apiDevicePlanChangeCreateDevicePlanChangeRequestPost({
    createDevicePlanChangeRequest: {
      action: action,
      mac_address: macAddress,
    },
  });
};

export const getAllDevicePlanChangeRequests = async () => {
  const api = getDevicePlanChangeApi();
  return await api.apiDevicePlanChangeGetAllDevicePlanChangeRequestsGet();
};

export const deleteDevicePlanChangeRequest = async (id: string) => {
  const api = getDevicePlanChangeApi();
  return await api.apiDevicePlanChangeDeleteDevicePlanChangeRequestDelete({
    deleteDevicePlanChangeRequest: { id: id },
  });
};
